import { TableHead } from '@/components/ui/table';
import type { SortState } from '@/lib/useTableSort';

export function SortableHead<K extends string>({
  children,
  sortKey,
  sort,
  onToggle,
  className = '',
}: {
  children: React.ReactNode;
  sortKey: K;
  sort: SortState<K>;
  onToggle: (key: K) => void;
  className?: string;
}) {
  const active = sort?.key === sortKey;
  const indicator = active ? (sort.dir === 'asc' ? ' ↑' : ' ↓') : ' ↕';

  return (
    <TableHead
      className={`cursor-pointer select-none ${className}`}
      onClick={() => onToggle(sortKey)}
    >
      <span className="inline-flex items-center gap-0.5">
        {children}
        <span className={`text-xs ${active ? 'text-foreground' : 'text-muted-foreground/70'}`}>
          {indicator}
        </span>
      </span>
    </TableHead>
  );
}
